import * as ActionTypes from 'actions/partnerPlanReminderNotification'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  reminderNotifications: [],
}

// Updates error message to notify about the failed fetches.
export default function partnerPlanReminderNotification(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLAN_REMINDERS_SEND_RECEIVED:
    case ActionTypes.PARTNERPLAN_REMINDERS_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERPLAN_REMINDERS_SEND_COMPLETE:
    case ActionTypes.PARTNERPLAN_REMINDERS_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        reminderNotifications: action.reminderNotifications,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlanReminderNotification.js